export default "__VITE_ASSET__ERTzy5xz__"